import { ImageFromServer } from '@/components/images/ImageFromServer';
import { MuscleTag } from '@/generated';
// import { useThesaurusTranslation } from '@/hooks/use-thesaurus-translation.hook';
import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { safeSchema } from '@/utils/rehype';
import rehypeSanitize from 'rehype-sanitize';
import { ClickableTag } from './MuscleTagEditor';
import { useMuscleTagsQuery } from '@/hooks/query-hooks';

export type MuscleInfoCardProps = {
  muscleTag?: MuscleTag;
  onTagClick?: (tag: MuscleTag) => void;
};

export const MuscleInfoCard = (props: MuscleInfoCardProps) => {
  const { muscleTag } = props;
  const { muscleTags } = useMuscleTagsQuery();
  // const { translate } = useThesaurusTranslation();

  return (
    <Card sx={{ minHeight: 150 }}>
      <CardContent sx={{ height: '100%' }}>
        <Grid sx={{ height: '100%', rowGap: 2 }} container>
          <Grid sx={{ alignItems: 'center', justifyItems: 'flex-start', alignContent: 'center', justifyContent: 'center', m: 1 }} size={3}>
            <Stack>
              <Typography sx={{ overflowWrap: 'break-word', mb: 3 }} variant="h6">
                {muscleTag?.name ?? 'No Name'}
              </Typography>
              {props.muscleTag?.imageId ? <ImageFromServer sx={{ maxWidth: '90%', maxHeight: 250 }} thumbnail={true} alt="" id={props.muscleTag.imageId} /> : <></>}
            </Stack>
          </Grid>

          <Grid size={8}>
            <Stack sx={{ alignContent: 'center', flexDirection: 'row' }}></Stack>
            <Grid container>
              <Grid size={12}>
                <ReactMarkdown rehypePlugins={[rehypeRaw, [rehypeSanitize, safeSchema]]} remarkPlugins={[remarkGfm]}>
                  {props.muscleTag?.description && props.muscleTag?.description !== '' ? props.muscleTag.description : 'No description available'}
                </ReactMarkdown>
              </Grid>
              {props.muscleTag?.groupMuscleTagIds?.length ? (
                <Grid size={12}>
                  <Typography variant="h6" sx={{ my: 2 }}>
                    Composed of:
                  </Typography>
                  {props.muscleTag?.groupMuscleTagIds?.map((mid) => {
                    const tag = muscleTags?.find((mt) => mt.id === mid);
                    return tag ? (
                      <ClickableTag
                        tagClicked={() => {
                          if (props.onTagClick) props.onTagClick(tag);
                        }}
                        tag={tag}
                      />
                    ) : (
                      <></>
                    );
                  })}
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
